import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { API_BASE, authHeaders, Fetch } from '../../utils/Utils.js';
import PhoneNumberInput from '../../shared/inputs/PhoneNumberInput.js';
import LanguageInput from '../../shared/inputs/LanguageInput.js';
import ErrorMessage from '../../shared/ErrorMessage.js';
import SuccessMessage from '../../shared/SuccessMessage.js';
import './AddTeam.css';

const RoleTable = () => {
  const { t } = useTranslation();
  const check = '✓';
  const dash = '—';
  return (
    <table className="team-role-table">
      <thead>
        <tr>
          <th></th>
          <th>{t('owner')}</th>
          <th>{t('manager')}</th>
          <th>{t('messenger')}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{t('role_feature_dashboard')}</td>
          <td>{check}</td><td>{check}</td><td>{dash}</td>
        </tr>
        <tr>
          <td>{t('role_feature_billing')}</td>
          <td>{check}</td><td>{dash}</td><td>{dash}</td>
        </tr>
        <tr>
          <td>{t('role_feature_data')}</td>
          <td>{check}</td><td>{check}</td><td>{dash}</td>
        </tr>
        <tr>
          <td>{t('role_feature_whatsapp')}</td>
          <td>{check}</td><td>{check}</td><td>{check}</td>
        </tr>
      </tbody>
    </table>
  );
};

const AddTeam = ({ onSuccess }) => {
  const { t } = useTranslation();
  const [role, setRole] = useState('');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone_number, setPhoneNumber] = useState('');
  const [ranchID, setRanchID] = useState('');
  const [ranches, setRanches] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const language = navigator.language;

  useEffect(() => {
    Fetch('/api/ranches', 'GET', null,
      (data) => {
        const list = data || [];
        setRanches(list);
        if (list.length > 0) setRanchID(list[0]._id);
      },
      () => {}
    );
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!role) return;
    setError('');
    setSuccess('');
    setLoading(true);

    if (role === 'manager') {
      fetch(`${API_BASE}/api/invite`, {
        method: 'POST',
        headers: authHeaders({ 'Content-Type': 'application/json' }),
        body: JSON.stringify({ email }),
      })
        .then(r => {
          if (r.ok) return null;
          if (r.status === 409) throw new Error(t('error_user_exists'));
          throw new Error(t('invite_error'));
        })
        .then(() => {
          setSuccess(t('invite_sent'));
          setTimeout(() => onSuccess && onSuccess(), 1500);
        })
        .catch(err => setError(err.message))
        .finally(() => setLoading(false));
    } else {
      const lang = document.querySelector('[name="lang"]')?.value || language;
      fetch(`${API_BASE}/api/data/teams`, {
        method: 'POST',
        headers: authHeaders({ 'Content-Type': 'application/json' }),
        body: JSON.stringify({ name, phone_number, lang, role: 'messenger', status: 'active', ranch_id: ranchID || undefined }),
      })
        .then(r => {
          if (r.ok) { onSuccess && onSuccess(); return; }
          throw new Error(t('error_adding_team'));
        })
        .catch(err => setError(err.message))
        .finally(() => setLoading(false));
    }
  };

  return (
    <div className="add-team-layout">
      <form className="DataCollectionAdd add-team-form" onSubmit={handleSubmit}>
        <select value={role} onChange={e => setRole(e.target.value)} required>
          <option value="">{t('select_role')}</option>
          <option value="manager">{t('manager')}</option>
          <option value="messenger">{t('messenger')}</option>
        </select>

        {role === 'manager' && (
          <input
            type="email"
            placeholder={t('email')}
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
          />
        )}

        {role === 'messenger' && (
          <>
            <input
              type="text"
              placeholder={t('name')}
              value={name}
              onChange={e => setName(e.target.value)}
            />
            <PhoneNumberInput language={language} onChange={setPhoneNumber} phoneNumber={phone_number} />
            <LanguageInput />
            {ranches.length > 1 && (
              <select value={ranchID} onChange={e => setRanchID(e.target.value)}>
                {ranches.map(r => (
                  <option key={r._id} value={r._id}>{r.name}</option>
                ))}
              </select>
            )}
          </>
        )}

        {role && (
          <button type="submit" disabled={loading}>
            {loading ? t('loading') + '...' : role === 'manager' ? t('send_invite') : t('add_button')}
          </button>
        )}

        <ErrorMessage message={error} />
        <SuccessMessage message={success} />
      </form>

      <div className="add-team-role-guide">
        <RoleTable />
      </div>
    </div>
  );
};

export default AddTeam;
